import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import {useTranslation} from "react-i18next";
import {useCurrentUser} from "../../../auth/CurrentUserProvider";


const StationWritePermissionCheckBox = ({ value, onChange}) => {
    const {t} = useTranslation("inputs");
    const {currentUser} = useCurrentUser();
    const disabled = currentUser.data?.role === "ADMIN" || currentUser.data?.role === "WG_ADMIN";

    return <FormGroup>
        <FormControlLabel
            control={<Checkbox checked={value}
                               size="small"
                               color="info"
                               disabled={disabled}
                               onChange={(e) => onChange(e.target.checked)}/>}
            label={<Typography color="text.secondary" variant="body2">{t('stationWritePermissionCheckBox.label')}</Typography>}/>
    </FormGroup>
}

export default StationWritePermissionCheckBox;